import styles from "./modal.module.scss";

const Modal = ({open, onClose, children, closeButton}) => {
    if (!open) return null;

    return (
        <div className={styles.Modal}>
            <div>
                <div>
                    <div className={styles.ModalContent} onClick={(e) => e.stopPropagation()}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Modal;